import { FunctionalComponent, h } from 'preact';
import { styled } from 'linaria/react';

import { CheckIcon } from 'ui/icons/check-icon';

type StatusBlockProps = {
	status: 'success' | 'warning';
};

export const StatusBlock: FunctionalComponent<StatusBlockProps> = (props) => {
	const { children, status } = props;
	const borderColor = status === 'success' ? '#D9D9D9' : '#FA8C16';

	return (
		<InfoBlockContainer
			style={{
				borderColor: borderColor,
			}}
		>
			<IconContainer>
				{status === 'success' ?
					<CheckIcon/> :
					<WarningIcon/>}
			</IconContainer>
			{typeof children === 'string' ? (
				<div
					// @ts-ignore
					dangerouslySetInnerHTML={{
						__html: children,
					}}
				/>
			) : (
				<div>{children}</div>
			)}
		</InfoBlockContainer>
	);
};

const WarningIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8 0.25C3.71875 0.25 0.25 3.72125 0.25 8C0.25 12.2787 3.71875 15.75 8 15.75C12.2812 15.75 15.75 12.2812 15.75 8C15.75 3.71875 12.2812 0.25 8 0.25ZM8 12C7.80222 12 7.60888 11.9414 7.44443 11.8315C7.27998 11.7216 7.15181 11.5654 7.07612 11.3827C7.00043 11.2 6.98063 10.9989 7.01921 10.8049C7.0578 10.6109 7.15304 10.4327 7.29289 10.2929C7.43275 10.153 7.61093 10.0578 7.80491 10.0192C7.99889 9.98063 8.19996 10.0004 8.38268 10.0761C8.56541 10.1518 8.72159 10.28 8.83147 10.4444C8.94135 10.6089 9 10.8022 9 11C9 11.2652 8.89464 11.5196 8.70711 11.7071C8.51957 11.8946 8.26522 12 8 12ZM9.195 4.54969L8.795 8.54969C8.78268 8.67308 8.72495 8.78748 8.63301 8.8707C8.54108 8.95391 8.4215 8.99999 8.2975 9H7.70375C7.57975 8.99999 7.46017 8.95391 7.36824 8.8707C7.27631 8.78748 7.21857 8.67308 7.20625 8.54969L6.80625 4.54969C6.79932 4.48029 6.80698 4.41021 6.82875 4.34395C6.85052 4.27769 6.88591 4.21671 6.93264 4.16495C6.97938 4.11318 7.03643 4.07176 7.10012 4.04335C7.16382 4.01494 7.23276 4.00018 7.3025 4H8.6975C8.76735 4 8.83642 4.01464 8.90027 4.04297C8.96411 4.0713 9.02132 4.11269 9.06819 4.16448C9.11506 4.21627 9.15056 4.2773 9.1724 4.34365C9.19424 4.41 9.20194 4.48018 9.195 4.54969Z"
			fill="#F8E5B9"/>
		<path
			d="M8.69722 4H7.30222C7.23237 4 7.1633 4.01464 7.09945 4.04297C7.03561 4.0713 6.9784 4.11269 6.93153 4.16448C6.88466 4.21627 6.84916 4.2773 6.82732 4.34365C6.80548 4.41 6.79778 4.48018 6.80472 4.54969L7.20472 8.54969C7.21704 8.67308 7.27478 8.78748 7.36671 8.8707C7.45864 8.95391 7.57822 8.99999 7.70222 9H8.29597C8.41997 8.99999 8.53955 8.95391 8.63148 8.8707C8.72342 8.78748 8.78115 8.67308 8.79347 8.54969L9.19347 4.54969C9.2004 4.48029 9.19274 4.41021 9.17097 4.34395C9.1492 4.27769 9.11382 4.21671 9.06708 4.16495C9.02034 4.11318 8.96329 4.07176 8.8996 4.04335C8.8359 4.01494 8.76697 4.00018 8.69722 4ZM7.99972 10C7.80194 10 7.6086 10.0586 7.44415 10.1685C7.2797 10.2784 7.15153 10.4346 7.07584 10.6173C7.00015 10.8 6.98035 11.0011 7.01894 11.1951C7.05752 11.3891 7.15276 11.5673 7.29261 11.7071C7.43247 11.847 7.61065 11.9422 7.80463 11.9808C7.99861 12.0194 8.19968 11.9996 8.38241 11.9239C8.56513 11.8482 8.72131 11.72 8.83119 11.5556C8.94107 11.3911 8.99972 11.1978 8.99972 11C8.99972 10.7348 8.89436 10.4804 8.70683 10.2929C8.51929 10.1054 8.26494 10 7.99972 10Z"
			fill="#983705"/>
	</svg>
);

const InfoBlockContainer = styled('div')`
	display: flex;
	padding: 8px 12px;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	color: #262626;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	
	strong {
		color: #6d14dc;
	}
`;
const IconContainer = styled('div')`
	display: flex;
	align-items: center;
	height: 24px;
	margin-right: 9px;
`;
